type NavigationItem = {
  name: string
  path: string
  icon?: string
  disabled?: boolean
  auth?: { roles?: string[]; requiresAdminGroups?: boolean }
  children?: NavigationItem[]
}

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    items: [] as NavigationItem[],
    lockNavigation: ref(localStorage.getItem('lockNavigation') === 'true'), // Initialize from localStorage
    temporaryOpenNavigation: false,
  }),
  getters: {
    hasVisibleItems(state) {
      const authStore = useAuthStore()

      const isVisible = (route: NavigationItem): boolean => {
        if (!authStore.isAuthorized(route.auth)) return false
        if (route.path) return true
        if (route.children?.length) return route.children.some(isVisible)
        return false
      }

      return (state.items ?? []).some(isVisible)
    },
  },
  actions: {
    setItems(items: NavigationItem[]) {
      this.items = items
    },
    // Update the action to set lockNavigation
    setLockNavigation(value: boolean) {
      this.lockNavigation = value
      localStorage.setItem('lockNavigation', value.toString())
    },
    toggleLockNavigation() {
      this.setLockNavigation(!this.lockNavigation)
    },
    requestTemporaryOpenNavigation() {
      this.temporaryOpenNavigation = true
    },
    clearTemporaryOpenNavigation() {
      this.temporaryOpenNavigation = false
    },
  },
})
